import React from 'react';
import { Search, ArrowLeft, Loader2, X } from 'lucide-react';
import { useAiCommandPalette } from '../context/AiCommandPaletteContext';

const ContextTag = ({ context, onRemove }) => {
  return (
    <div className="flex items-center bg-gray-200/70 dark:bg-neutral-900 text-gray-700 dark:text-neutral-500 text-xs rounded-lg pl-2 pr-1 h-7 whitespace-nowrap">
      <span className="truncate text-xs max-w-[130px]">{context.label}</span>
      <button 
        onClick={onRemove}
        className="ml-0.5 flex items-center justify-center h-3.5 w-3.5 rounded-sm hover:bg-gray-300/70 dark:hover:bg-gray-600/40 flex-shrink-0"
        title="Remove context"
      >
        <X className="h-2.5 w-2.5" />
      </button>
    </div>
  );
};

const SearchInput = () => {
  const {
    inputValue,
    setInputValue,
    handleInputChange,
    handleKeyDown,
    isLoading,
    isAskMode,
    handleBackToSearch,
    inputRef,
    contextIndicator,
    removeContext
  } = useAiCommandPalette();

  return (
    <div className="relative border-b border-violet-500/10 dark:border-violet-500/30">
      {isAskMode ? (
        <div className="absolute left-2.5 top-1/2 -translate-y-1/2 flex items-center gap-2">
          <button 
            onClick={handleBackToSearch}
            className="flex items-center justify-center hover:bg-violet-500/15 h-7 w-7 rounded-lg text-violet-500 transition-colors"
            title="Return to search"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        </div>
      ) : (
        <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-2">
          <Search className="h-4 w-4 text-violet-500" />
        </div>
      )}
      
      <div className="flex items-center pl-11 pr-11 py-4 overflow-hidden">
        {contextIndicator && (
          <div className="flex-shrink-0 mr-2 my-[-2px]">
            <ContextTag context={contextIndicator} onRemove={removeContext} />
          </div>
        )}
        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => handleInputChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={
            isAskMode 
              ? "Ask StatusBot a follow up question..." 
              : "Search or ask StatusBot..."
          }
          className="w-full bg-transparent focus:outline-none text-foreground placeholder-gray-400 dark:placeholder-white/40 overflow-ellipsis"
        />
      </div>

      <div className="absolute right-4 top-1/2 -translate-y-1/2">
        {isLoading && (
          <Loader2 className="h-4 w-4 animate-spin text-violet-500" />
        )}
      </div>
    </div>
  );
};

export default SearchInput; 